function SeMailchimpForm(container) {
    this.container = container;
    this.form = this.container.querySelector('.jsSignupNewsletterForm');
    this.emailInput = this.form.querySelector('.jsSignupNewsletterEmailInput');
    this.errorMsg = this.form.querySelector('.jsSignupFormErrorMsg');
    this.successMsg = this.form.querySelector('.jsSignupFormSuccessMsg');
    this.isSubmitting = false;
    
    this.form.addEventListener('submit', e => {
        e.preventDefault();
        this.submitForm();
    });
}

SeMailchimpForm.prototype.submitForm = function() {
    if (! this.isSubmitting) {
        if (! this.emailInput.value || this.emailInput.value === '') {
            this.showErrorMessage('Please enter your email address.');
            return false;
        }
        
        this.isSubmitting = true;

        // Submit the form
        const xmlhttp = new XMLHttpRequest();
        const params = new FormData();

        params.append('action', 'se_submit_mailchimp_signup');
        params.append('email', this.emailInput.value);

        xmlhttp.onreadystatechange = _ => {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) {
                this.isSubmitting = false;

                if (xmlhttp.status === 200) {
                    const response = JSON.parse(xmlhttp.responseText);

                    if (response.success) this.showSuccessMessage();
                    else this.showErrorMessage(response.error);
                }
                else {
                    this.showErrorMessage('Oops.. Something went wrong. Please try again.');
                }
            }
        };

        xmlhttp.open('POST', se_ajax.ajaxurl, true);
        xmlhttp.send(params);
    }
};

SeMailchimpForm.prototype.showErrorMessage = function(errorMessage) {
    this.errorMsg.innerHTML = errorMessage;
    this.successMsg.style.display = 'none';
    this.errorMsg.style.display = 'block';
}

SeMailchimpForm.prototype.showSuccessMessage = function() {
    this.emailInput.value = '';
    this.errorMsg.style.display = 'none';
    this.successMsg.style.display = 'block';
}